import { HorizontalAlign } from 'src/ui/types/align';
import styled, { css, ExecutionContext } from 'styled-components';

interface TableCellProps {
  $alignContent?: HorizontalAlign;
}

export const DataRecordTable = styled.div`
  width: 100%;
  overflow-x: auto;
`;

function getAlignContent({ $alignContent }: ExecutionContext & TableCellProps) {
  if ($alignContent === 'right') {
    return css`
      justify-content: flex-end;
    `;
  }

  if ($alignContent === 'center') {
    return css`
      justify-content: center;
    `;
  }
}

export const CellContainer = styled.div<TableCellProps>`
  display: flex;
  ${getAlignContent};
`;

export const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 24px 0;
`;
